import Papa from 'papaparse'
import jsPDF from 'jspdf'
import 'jspdf-autotable'

export const exportToCSV = <T extends Record<string, any>>(
  data: T[],
  filename: string,
  columns: { header: string; field: keyof T | string }[]
) => {
  const csvData = data.map((row) => {
    const csvRow: Record<string, any> = {}
    columns.forEach((col) => {
      csvRow[col.header] = row[col.field as keyof T]
    })
    return csvRow
  })

  const csv = Papa.unparse(csvData)
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
  const link = document.createElement('a')
  const url = URL.createObjectURL(blob)
  link.setAttribute('href', url)
  link.setAttribute('download', `${filename}.csv`)
  link.style.visibility = 'hidden'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

export const exportToPDF = <T extends Record<string, any>>(
  data: T[],
  filename: string,
  title: string,
  columns: { header: string; field: keyof T | string }[]
) => {
  const doc = new jsPDF()
  doc.text(title, 14, 15)

  const tableData = data.map((row) =>
    columns.map((col) => {
      const value = row[col.field as keyof T]
      return value !== null && value !== undefined ? String(value) : ''
    })
  )

  const tableHeaders = columns.map((col) => col.header)

  ;(doc as any).autoTable({
    head: [tableHeaders],
    body: tableData,
    startY: 20,
  })

  doc.save(`${filename}.pdf`)
}

